import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { ISCMSaleDcSearch, ISCMSaleDcDetail, ISCMSaleDcStatistics, ISCMSaleDcInsert, ISCMSaleDcUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./saleDcTypes";
import { IEntityDetail } from "@/views/organization/entity/entityType";

export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}


export interface IFmsShopUnitDetail {
    bentityList: IEntityDetail[],
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class SaleDcService {
    async page(searchVo: ISCMSaleDcSearch) {
        // const apiUrl = "/hd-sms/transfer/to/listPage";
        const apiUrl = "/zzw-vrm/transfer/to/listPage";
        return await httpRequest.post<IPage<ISCMSaleDcDetail>>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMSaleDcSearch) {
        // const apiUrl = "/hd-sms/transfer/to/TransferInSummary";
        const apiUrl = "/zzw-vrm/transfer/to/TransferInSummary";
        return await httpRequest.post<ISCMSaleDcStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        // const apiUrl = `/hd-sms/transfer/to/findByIdOrCode/${id}`;
        const apiUrl = `/zzw-vrm/transfer/to/findByIdOrCode/${id}`;
        return await httpRequest.get<ISCMSaleDcDetail>(apiUrl);
    }
    async insert(insertVo: ISCMSaleDcInsert) {
        // const apiUrl = "/hd-sms/transfer/to/insert";
        const apiUrl = "/zzw-vrm/transfer/to/insert";
        return await httpRequest.post<any>(apiUrl, insertVo);
    }
    async update(updateVo: ISCMSaleDcUpdate) {
        // const apiUrl = "/hd-sms/transfer/to/update";
        const apiUrl = "/zzw-vrm/transfer/to/update";
        return await httpRequest.post<any>(apiUrl, updateVo);
    }
    //查询站点结算单位的 下属关联
    async queryShopUnitBe(shopId: string) {
        const apiUrl = `/fms/no/accountUnit/find/one/${shopId}`;
        return await httpRequest.post<IFmsShopUnitDetail>(apiUrl);
    }
    //驳回
    async reject(id: string) {
        // const apiUrl = `/hd-sms/transfer/to/reject/${id}`;
        const apiUrl = `/zzw-vrm/transfer/to/reject/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //调入调出   调入：0，调出 1
    async whConfirm(obj: { inAndOut: string, id: string }) {
        // const apiUrl = `/hd-sms/transfer/to/whConfirm`;
        const apiUrl = `/zzw-vrm/transfer/to/whConfirm`;
        return await httpRequest.post<IFmsShopUnitDetail>(apiUrl, obj);
    }

    async export(searchVo: ISCMSaleDcSearch) {
        // const apiUrl = "/hd-sms/transfer/to/export";
        const apiUrl = "/zzw-vrm/transfer/to/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    //列表明细导出
    async statisticsExport(searchVo: ISCMSaleDcSearch) {
        // const apiUrl = "/hd-sms/transfer/to/statisticsExport";
        const apiUrl = "/zzw-vrm/transfer/to/statisticsExport";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }
    async print(id: string) {
        // const apiUrl = `/hd-sms/transfer/to/print/${id}`;
        const apiUrl = `/zzw-vrm/transfer/to/print/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //调出单明细下载模板
    async downloadTpl() {
        // const appPageUrl = "/hd-sms/transfer/to/detail/downloadTpl";
        const appPageUrl = "/zzw-vrm/transfer/to/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }
    //导出调出单明细
    async exportDetail(code: string) {
        // const appPageUrl = `/hd-sms/transfer/to/exportDetails/${code}`;
        const appPageUrl = `/zzw-vrm/transfer/to/exportDetails/${code}`;
        return await httpRequest.getFile(appPageUrl);
    }
    //供应链采购明细查询接口
    async scm2TransferDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/scm2/purchase/po/transfer/details";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //云修采购明细查询接口
    async vrm2TransferDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/zzw-vrm/stock/details/transfer/details";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //业务系统库房确认接口
    async vrm2WhConfirm(searchVo: ISCMSaleDcUpdate) {
        const apiUrl = "/zzw-vrm/stock/details/whConfirm";
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }

    async check(branchIn: string, params: object) {
        const apiUrl = `hd-vrm/base/material/checkMaterialExist`
        return await httpRequest.post<any>(apiUrl, params)
    }
    async checkScm(branchIn: string, params: object) {
        const apiUrl = `hd-vrm/purchase/po/checkMaterialExist`
        return await httpRequest.post<any>(apiUrl, params)
    }
}

export const saleDcService = new SaleDcService();